import {
    Button,
    Card,
    Container,
    Divider,
    Dropdown,
    Icon,
    IconButton,
    Stack,
    Text,
    TextInput,
    styled,
} from 'shell/components';

const Mobile = ({
    assignment,
    sortedFilteredSubmissions,
    getSubmissionStatus,
    getSubmissionFinalGrade,
    onClickBack,
    onClickViewAll,
    onClickViewSubmission,
    onSelect,
    filters,
    setFilters,
    getFilterCount,
    sortState,
}) => {
    return (
        <Container sx={{ height: '100%' }} device={'mobile'}>
            <RootStack spacing={5}>
                <Button
                    sx={{ alignSelf: 'flex-start' }}
                    startIcon={<Icon kind={'arrowLeft'} />}
                    variant={'borderless'}
                    onClick={onClickBack}
                >
                    Back
                </Button>
                <Stack alignItems={'center'} direction={'row'} spacing={2}>
                    <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                        {assignment.title}
                    </Text>
                    <Dropdown
                        id={'grades-and-feedback-dropdown'}
                        options={[
                            {
                                key: 'csv',
                                value: 'Export Grades/Feedback',
                                disabled: sortedFilteredSubmissions.every(({ grading }) => !grading),
                            },
                            { key: 'delete', value: 'Reset Grading/Feedback' },
                        ]}
                        rootComponent={
                            <IconButton
                                aria-label={'more options'}
                                kind={'moreHorizontal'}
                                size={'medium'}
                                variant={'square'}
                            />
                        }
                        onSelect={onSelect}
                    />
                </Stack>
                <Stack alignItems={'center'} direction={'row'} spacing={4}>
                    <Button
                        sx={{ flexShrink: 0 }}
                        color={'neutral'}
                        startIcon={<Icon kind={'filter'} />}
                        variant={'secondary'}
                        onClick={() => setFilters((current) => ({ ...current, open: true }))}
                    >
                        ({getFilterCount(filters, sortState)})
                    </Button>
                    <TextInput
                        endIcon={<Icon kind={'search'} />}
                        placeholder={'Search'}
                        value={filters.search}
                        onChange={(e) => setFilters((current) => ({ ...current, search: e.target.value }))}
                    />
                </Stack>
                <Stack divider={<Divider />} spacing={3}>
                    <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                        <Text color={'light'}>Grades/Feedback</Text>
                        <Button
                            disabled={sortedFilteredSubmissions.every((submission) => !submission.grading)}
                            variant={'borderless'}
                            onClick={onClickViewAll}
                        >
                            View All
                        </Button>
                    </Stack>
                    <Stack spacing={5}>
                        {sortedFilteredSubmissions.map((submission) => (
                            <Card key={submission.id}>
                                <Stack sx={{ minWidth: 0, width: '100%' }} divider={<Divider />} spacing={2}>
                                    <Stack
                                        alignItems={'flex-start'}
                                        direction={'row'}
                                        justifyContent={'space-between'}
                                        spacing={2}
                                    >
                                        <Text sx={{ minWidth: 0 }} variant={'h6'} weight={'semibold'}>
                                            {submission.data.original_file
                                                ? submission.data.original_file.name
                                                : submission.data.name}
                                        </Text>
                                        <Button
                                            disabled={!submission.grading}
                                            variant={'borderless'}
                                            onClick={() => onClickViewSubmission(submission)}
                                        >
                                            View
                                        </Button>
                                    </Stack>
                                    <Stack spacing={2}>
                                        <Stack alignItems={'center'} direction={'row'} spacing={1}>
                                            <Text color={'light'}>Status:</Text>
                                            {getSubmissionStatus(submission)}
                                        </Stack>
                                        <Text color={'light'}>Final Grade: {getSubmissionFinalGrade(submission)}</Text>
                                    </Stack>
                                </Stack>
                            </Card>
                        ))}
                    </Stack>
                </Stack>
            </RootStack>
        </Container>
    );
};

const RootStack = styled(Stack)(({ theme }) => {
    return {
        width: '100%',
        paddingBottom: theme.spacing(5),
    };
});

export default Mobile;
